<template>
  <div class="content2">
    <vue-headful
    title="Dashboard | My Logos"
    description="Dashboard | My Logos"
/>

<div class="sc-kAdXeD jwoEpG" style="padding: 40px 20px 0px !important;">
  <div class="sc-bvTASY jPMoWD">
    <div class="sinpaddingmobile" style="display: flex; justify-content: space-between; padding-top: 60px;">
      <h4 class="f342fdw" style="color: rgb(74, 80, 115);"><i class="fa-solid fa-icons mr-2"></i> Exclusive Deals</h4> 
    </div>
    <p>Save up to $4,500 while growing your business through our exclusive deals.</p>
    <hr>
  </div>
</div>

<div class="sc-bvTASY jPMoWD">
  <div class="row">
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/stripe-atlas.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Gain Access</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Stripe Atlas</h4>
            <p class="card-text my-2">Incorporate your startup</p>
            <small class="text-muted">Stripe Atlas streamlines the process of starting a global business, providing tools for company formation, banking, and payment processing.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://stripe.com/atlas">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/intuit-quickbooks.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Save $144</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Intuit QuickBooks</h4>
            <p class="card-text my-2">Save 75% for 6 months</p>
            <small class="text-muted">Intuit QuickBooks simplifies accounting and financial management for small businesses with powerful tools and intuitive interfaces.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://refer.quickbooks.ca/s/franco">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/wix.webp" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Gain Access</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Wix</h4>
            <p class="card-text my-2">Create a website without limits</p>
            <small class="text-muted">Create your website and grow with confidence. From an intuitive website builder to advanced business solutions & powerful SEO tools</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://www.wix.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/google-ads.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Save $500</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Google Ads</h4>
            <p class="card-text my-2">Get $500 in free ad credit</p>
            <small class="text-muted">Google Ads helps businesses attract more customers by displaying ads in Google search results and across the web.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://ads.google.com/home/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/microsoft-advertising.webp" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Save $250</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Microsoft Advertising</h4>
            <p class="card-text my-2">Receive $250 in credits when you spend $50</p>
            <small class="text-muted">Microsoft Advertising connects businesses with potential customers through targeted ads on Bing, Yahoo, and partner sites.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://ads.microsoft.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/1password.webp" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Gain Access</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>1Password</h4>
            <p class="card-text my-2">Password Manager</p>
            <small class="text-muted">1Password securely stores and manages your passwords, ensuring easy access and robust protection for your digital life.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://1password.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/xero.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Try for FREE</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Xero</h4>
            <p class="card-text my-2">Accounting software to do your to-do</p>
            <small class="text-muted">Xero offers cloud-based accounting software designed for small businesses, simplifying financial management and bookkeeping.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://www.xero.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/hubspot.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Try for FREE</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>HubSpot</h4>
            <p class="card-text my-2">Free 30-day trial</p>
            <small class="text-muted">HubSpot provides comprehensive marketing, sales, and customer service software to help businesses grow and enhance customer relationships.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://www.hubspot.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/typeform.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Free Access</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Typeform</h4>
            <p class="card-text my-2">Free 30-day trial</p>
            <small class="text-muted">Typeform creates engaging, conversational forms and surveys, enhancing user experience and boosting response rates.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://typeform.cello.so/bgMcrt6kaQl">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/sprout-social.webp" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Save up to 25%</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Sprout Social</h4>
            <p class="card-text my-2">Powerful solution for social media management</p>
            <small class="text-muted">Sprout Social offers powerful social media management tools to streamline content planning, publishing, and analytics.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://sproutsocial.pxf.io/c/5556004/1970543/19698">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/semrush.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Lorem Ipsum</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Semrush</h4>
            <p class="card-text my-2">Lorem Ipsum Lorem Ipsum</p>
            <small class="text-muted">Semrush provides comprehensive SEO and marketing tools to enhance online visibility and drive digital growth.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="#">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div> -->
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/deel.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Free</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Deel</h4>
            <p class="card-text my-2">Payroll for global teams</p>
            <small class="text-muted">Deel simplifies global payroll and compliance for remote teams, making international hiring and payments easy and efficient.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://www.deel.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/zoom.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Free</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Zoom</h4>
            <p class="card-text my-2">One platform to connect</p>
            <small class="text-muted">Zoom offers reliable video conferencing and communication tools for virtual meetings, webinars, and online collaboration.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://zoom.us/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/squarespace.webp" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Free trial</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Squarespace</h4>
            <p class="card-text my-2">Get your free website trial today</p>
            <small class="text-muted">Squarespace provides an all-in-one platform for building beautiful websites, online stores, and portfolios with ease.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://www.squarespace.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/shopify.webp" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">$1 Access</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Shopify</h4>
            <p class="card-text my-2">Enjoy your first month for just $1</p>
            <small class="text-muted">Shopify enables businesses to create, customize, and manage online stores, offering tools for e-commerce success.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://shopify.pxf.io/logodesign">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/google-cloud.webp" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Start for free</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Google Cloud</h4>
            <p class="card-text my-2">Get $300 in free credits</p>
            <small class="text-muted">Google Cloud provides scalable, secure cloud solutions for businesses, enhancing infrastructure, data management, and application development.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://cloud.google.com">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/convertkit.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Free trial</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>ConvertKit</h4>
            <p class="card-text my-2">Sustainable growth tools for creators</p>
            <small class="text-muted">ConvertKit offers powerful email marketing tools for creators, helping to grow audiences and increase engagement.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://convertkit.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/mercury.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Gain Access</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Mercury</h4>
            <p class="card-text my-2">Smart banking</p>
            <small class="text-muted">Mercury provides modern banking solutions tailored for startups and small businesses, offering seamless financial management.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://mercury.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/godaddy.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Discounted extensions</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Godaddy</h4>
            <p class="card-text my-2">Register your new domain</p>
            <small class="text-muted">GoDaddy offers domain registration, website hosting, and online business solutions to help individuals and businesses establish their online presence.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://www.godaddy.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/square.webp" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Free sign up</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Square</h4>
            <p class="card-text my-2">Sell anywhere easily, quickly, and seamlessly</p>
            <small class="text-muted">Square provides versatile payment solutions and business tools to streamline sales, from in-person transactions to online stores.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://squareup.com/signup">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/hostinger.webp" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">2 Months Free</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Hostinger</h4>
            <p class="card-text my-2">Everything You Need to Create a Website</p>
            <small class="text-muted">Hostinger offers affordable web hosting solutions with robust features, ensuring fast and reliable website performance.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://www.hostinger.com/">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 d-flex">
      <div class="blog-card w-100">
        <div class="card shadow-soft border-light h-100">
          <img src="/exclusive-deals/bluehost.png" class="card-img-top" style="height: 120px;" alt="image">
          <div class="card-header">
            <div class="post-meta d-block d-sm-flex justify-content-between">
              <h6 class="icon-success mb-0">Free Domain for 1st Year</h6>
            </div>
          </div>
          <div class="card-body pt-0">
            <h4>Bluehost</h4>
            <p class="card-text my-2">The Best Web Hosting</p>
            <small class="text-muted">Bluehost provides reliable web hosting services with comprehensive tools for building and managing websites effortlessly.</small>
          </div>
          <div class="card-footer mx-4 px-0 pt-0">
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-success w-100" data-toggle="modal" data-target="#modal-exclusive-deals">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </button>
            <a v-else target="_blank" class="btn btn-success w-100" href="https://bluehost.sjv.io/logodesign">
              <span class="fas fa-award mr-2"></span>Claim Offer
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>

</template>

<style>
a {
  color: #515151;
}
.delete_btnhover:hover{
  color: #ee5150!important;
}
.preview_btnhover:hover{
  color: #073482!important;
}
.downloads_btnhover:hover{
  color: #073482!important;
}
</style>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
        hey: ''
      };
    },
    methods: {
    },
    mounted() {
      this.$emit('updatepath');
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/exclusive-deals.vue